export default {
  ON_AFTER_ADD_NEW_PAGE: 'onAfterAddNewPage',
  ON_AFTER_DELETE_PAGE: 'onAfterDeletePage',
  ON_AFTER_CHANGE_HOME_PAGE: 'onAfterChangeHomePage',
  ON_AFTER_CHANGE_PAGE_ORDER: 'onAfterChangePageOrder',
  ON_AFTER_SITE_CONNECT: 'onAfterSiteConnect',
  ON_AFTER_UPDATE_PAGE_SETTINGS: 'onAfterUpdatePageSettings',
  ON_INITIAL_SETUP_COMPLETE: 'onInitialSetupComplete',
  ON_AFTER_BLOCK_ADDED: 'onAfterBlockAdded',
  ON_AFTER_BLOCK_DUPLICATED: 'onAfterBlockDuplicated',
  ON_BEFORE_BLOCK_DELETED: 'onBeforeBlockDeleted',
  ON_AFTER_BLOCK_DELETED: 'onAfterBlockDeleted',
  ON_AFTER_BLOCK_SHIFTED: 'onAfterBlockShifted',
  ON_AFTER_BLOCK_COPIED: 'onAfterBlockCopied',
  ON_AFTER_BLOCK_CUTOUT: 'onAfterBlockCutout',
  ON_AFTER_BLOCK_PASTED: 'onAfterBlockPasted',
  ON_BEFORE_BLUR_FOCUSED_ELEMENT: 'onBeforeBlurFocusedElement',
  ON_AFTER_BLUR_FOCUSED_ELEMENT: 'onAfterBlurFocusedElement',
  ON_BEFORE_SITE_SAVE: 'onBeforeSiteSave',
  ON_AFTER_SITE_SAVE: 'onAfterSiteSave',
  ON_AFTER_ELEMENT_FOCUSED: 'onAfterElementFocused',
  ON_AFTER_ELEMENT_SELECTED: 'onAfterElementSelected',
  ON_AFTER_DIALOG_HIDE: 'onAfterDialogHide',

  // hdrm hooks
  ON_STATIC_DOCUMENT_CONNECTED: 'onStaticDocumentConnected',
  ON_LIVE_DOCUMENT_COMPOSED: 'onLiveDocumentComposed',
  ON_LIVE_DOCUMENT_CONNECTED: 'onLiveDocumentConnected',
  ON_BEFORE_SYNCHRONIZE_STATIC_ELEMENT: 'onBeforeSynchronizeStaticElement',
  ON_BEFORE_SYNCHRONIZE_LIVE_ELEMENT: 'onBeforeSynchronizeLiveElement',
  ON_BEFORE_INSERT_LIVE_ELEMENT: 'onBeforeInsertLiveElement',
  ON_BEFORE_SET_STATIC_ELEMENT_ATTRIBUTE: 'onBeforeSetStaticElementAttribute',
  ON_BEFORE_SET_LIVE_ELEMENT_ATTRIBUTE: 'onBeforeSetLiveElementAttribute',
  ON_BEFORE_REPLACE_STATIC_ELEMENT: 'onBeforeReplaceStaticElement',
  ON_BEFORE_REPLACE_LIVE_ELEMENT: 'onBeforeReplaceLiveElement',
  ON_BEFORE_INSERT_STATIC_ELEMENT: 'onBeforeInsertStaticElement',
  ON_BEFORE_DUPLICATE_STATIC_ELEMENT: 'onBeforeDuplicateStaticElement',
  ON_AFTER_DUPLICATE_STATIC_ELEMENT: 'onAfterDuplicateStaticElement',
  ON_AFTER_INSERT_STATIC_ELEMENT: 'onAfterInsertStaticElement',
  ON_AFTER_INSERT_LIVE_ELEMENT: 'onAfterInsertLiveElement',
  ON_AFTER_SHIFT_STATIC_ELEMENT: 'onAfterShiftStaticElement',
  ON_AFTER_REPLACE_LIVE_ELEMENT: 'onAfterReplaceLiveElement',
  ON_AFTER_SYNCHRONIZE_STATIC_ELEMENT: 'onAfterSynchronizeStaticElement',

  // view hooks
  ON_BEFORE_PAGE_LOADED: 'onBeforePageLoaded',

  // Live document event hooks
  ON_LIVE_DOCUMENT_COPY: 'ON_LIVE_DOCUMENT_COPY',
  ON_LIVE_DOCUMENT_PASTE: 'ON_LIVE_DOCUMENT_PASTE',
  ON_TEXT_PASTE: 'ON_TEXT_PASTE',
  ON_TEXT_COPY: 'ON_TEXT_COPY',
  ON_TEXT_CUT: 'ON_TEXT_CUT',
  ON_SITE_LOADED: 'ON_SITE_LOADED',

  // css generator hooks
  ON_BEFORE_CSS_GENERATOR_INIT: 'ON_BEFORE_CSS_GENERATOR_INIT',
};
